if($('body').hasClass('template--collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('.collection__results-product-list').height() - 400 < $(document).scrollTop()) {
      var loadingImage,
      pInfScrNode = $('.collection__results-product-list-more').last(),	
      pInfScrURL = $('.collection__results-product-list-more').last().attr("href");
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        // $('.collection__results').append('<img src="https://cdn.shopify.com/s/files/1/0635/5795/9924/files/loading.gif?v=1735378390" class="collection__results-product-list-loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            // $('.collection__results-product-list-more').hide();
            // loadingImage = pInfScrNode.clone().empty().append('');
            // loadingImage.insertAfter(pInfScrNode);
            // pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            console.log(data);
            pInfScrNode.remove();
            var filteredData = $(data).find(".collection__results-product-list");
            console.log('filteredData.length',filteredData);
            // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
            $('.collection__results-product-list').after(`<div class="product-list collection__results-product-list">${filteredData.html()}</div>`);
            $('.collection__results-product-list-more_wrapper').html($(data).find('.collection__results-product-list-more_wrapper').html());
            // loadingImage.remove();
            // $('.collection__results-product-list-loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    // $('body').on('click', '.collection__results-product-list-more', function(e) {
    //    e.preventDefault();
    //    $(this).attr("aria-busy","true");
    //    pInfScrExecute();
    // });
    // $(window).scroll(function(){
    //   $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
    //   if( $('.collection__results-product-list:last-child').height() - 400 < $(document).scrollTop()) {
    //     pInfScrDelay = 20;
    //   }
    // });
  });
}


$(document).ready(function() {
  $('.mobile-menu-link.has_submenu').click(function(e) {
    e.preventDefault();
    $(this).next('.panel__wrapper').toggle();
    
    // Toggle the aria-expanded attribute
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
});

  if($(window).width() < 999){
   document.addEventListener("listbox:change", function(event){
    const thissel = document.querySelector('facet-sort-by');    
    const url = new URL(location.href), sectionId = thissel.closest(".shopify-section").id.replace("shopify-section-", "");
    url.searchParams.set("sort_by", event.detail.value);
    url.searchParams.set("section_id", sectionId);
    url.searchParams.delete("page");
    document.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }); 
  }  
  
  $('.featured-collections_tab-item_link').click(function(e){
    e.preventDefault();
    $('.featured-collections_tab-item_link').removeClass('active');
    $(this).addClass('active');
    $(this).parents('.featured-collections_main').find('.featured-collections_item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).fadeIn();
    return false;
  });
  
  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
    console.log('text',text);
    
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    // copy_text.html('Copied');
    copy_text.addClass('active');
      
    setTimeout(function () {
      // copy_text.html('Copy');
      copy_text.removeClass('active');
    }, 1000);
  });
  
  $(".product-offer-content").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.footer-seo_toggle').click(function(){
    $(this).parents('.footer-seo').find('.footer-seo_wrap').toggle();
  });

  $('a[href^="/collections/"],a[href^="https://chowkhat.com/collections/"]').each(function(){
    var oldUrl = $(this).attr("href"); // Get current url
     if(oldUrl.indexOf('?') > -1){
      // var url = oldUrl+'&filter.v.availability=1'; 
     }else{
      var url = oldUrl+'?filter.v.availability=1';
      var newUrl = oldUrl.replace(oldUrl, url); // Create new url
      $(this).attr("href", newUrl); // Set herf value
     }         
  });
  $('.size_chart_table td').mouseenter(function(){
    var size = $(this).attr('size');
    $(this).parents('.size_chart_table').find(`th[size="${size}"]`).addClass("hoverd");
    $(this).parents('.size_chart_table').find(`td[size="${size}"]`).addClass("hoverd");
    $(this).parents('tr').find('td').addClass("hoverd");
    $(this).parents('tr').find('th').addClass("hoverd");
  });
  
  $(".size_chart_table td").mouseout(function(){
    var size = $(this).attr('size');
    $(this).parents('.size_chart_table').find(`th[size="${size}"]`).removeClass("hoverd");
    $(this).parents('.size_chart_table').find(`td[size="${size}"]`).removeClass("hoverd");
    $(this).parents('tr').find('td').removeClass("hoverd");
    $(this).parents('tr').find('th').removeClass("hoverd");
  });
  $('.size_chart_table th').mouseenter(function(){
    var size = $(this).attr('size');
    $(this).parents('.size_chart_table').find(`th[size="${size}"]`).addClass("hoverd");
    $(this).parents('.size_chart_table').find(`td[size="${size}"]`).addClass("hoverd");
    $(this).parents('tr').find('td').addClass("hoverd");
    $(this).parents('tr').find('th').addClass("hoverd");
  });
  
  $(".size_chart_table th").mouseout(function(){
    var size = $(this).attr('size');
    $(this).parents('.size_chart_table').find(`th[size="${size}"]`).removeClass("hoverd");
    $(this).parents('.size_chart_table').find(`td[size="${size}"]`).removeClass("hoverd");
    $(this).parents('tr').find('td').removeClass("hoverd");
    $(this).parents('tr').find('th').removeClass("hoverd");
  });
    
  $('body').on('click', '.size_chart_table-cm:not(.active)', function(){
      $('.size_chart_table-cm').addClass('active');
      $('.size_chart_table-inches').removeClass('active');
    
      // Iterate through all table cells except headers
      $(".size_chart_table td").each(function () {
          let value = parseFloat($(this).text()); // Get the cell value as a float
          if (!isNaN(value)) {
              let cmValue = (value * 2.54).toFixed(1); // Convert to cm
              $(this).text(cmValue); // Update the cell value
          }
      });
  });
  $('body').on('click', '.size_chart_table-inches:not(.active)', function(){
      $('.size_chart_table-inches').addClass('active');
      $('.size_chart_table-cm').removeClass('active');
    
      // Iterate through all table cells except headers
      $(".size_chart_table td").each(function () {
          let value = parseFloat($(this).text()); // Get the cell value as a float
          if (!isNaN(value)) {
              let cmValue = (value / 2.54).toFixed(0); // Convert to cm
              $(this).text(cmValue); // Update the cell value
          }
      });
  });

  var default_show_product_count = 8;
  var next_show_product_count = default_show_product_count * 2;
  
  $('.infinite-load-featured-collection-view-all_link').click(function(e){
     e.preventDefault();
     var _this = this;
     var total_product_count = parseInt($(this).attr('total-product-count'));
      console.log(default_show_product_count,next_show_product_count);
      $(".featured-collection--product-item").each(function(index) {
        if(parseInt($(this).attr('product-item-count')) <= next_show_product_count){
            console.log('index',index);
            if(total_product_count == (index + 1)){
                $(_this).hide();
            }
            $(this).show();
        }
      });
      next_show_product_count = default_show_product_count + next_show_product_count
  });
});